"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaAluno = exports.yupAluno = void 0;
const yup = __importStar(require("yup"));
const enums_1 = require("../enums");
const utils_1 = require("../utils");
const estado_1 = require("./estado");
exports.yupAluno = yup.object({
    nome: yup
        .string()
        .required('Campo nome é obrigatório')
        .label('Nome do aluno')
        .max(65, 'Máximo de 65 caracteres.')
        .default(''),
    nomeusual: yup.string().label('Nome usual do aluno').max(65, 'Máximo de 65 caracteres.').default(''),
    sexo: yup.mixed().label('Sexo').oneOf(Object.values(enums_1.ESexo)).required().default(enums_1.ESexo.Feminino),
    dataNasc: (0, utils_1.sge2Date)().label('Data de nascimento').nullable().default(null),
    cpf: yup.string().label('CPF').max(15, 'Máximo de 15 caracteres.').default(''),
    localNascimento: yup.string().label('Local de Nascimento').max(30, 'Máximo de 30 caracteres.').default(''),
    estadoLocalNascimento: yup
        .string()
        .label('Estado local de nascimento')
        .oneOf(estado_1.estado.map((m) => m.sigla).concat(['']))
        .default(''),
    rg: yup.string().label('RG').max(20, 'Máximo de 20 caracteres.').default(''),
    rgEstado: yup
        .string()
        .label('Estado RG')
        .oneOf(estado_1.estado.map((m) => m.sigla).concat(['']))
        .default(''),
    rgOrgaoExpedidor: yup.string().label('Orgão Expedidor').max(15, 'Máximo de 15 caracteres.').default(''),
    rgDataExpedicao: (0, utils_1.sge2Date)().label('Data expedição').nullable().default(null),
    cep: yup.string().label('CEP').max(10, 'Máximo de 10 caracteres.').default(''),
    endereco: yup.string().label('Endereço').max(55, 'Máximo de 55 caracteres.').default(''),
    numero: yup.string().label('Número').max(5, 'Máximo de 5 caracteres.').default(''),
    apto: yup.string().label('Apartamento').max(15, 'Máximo de 15 caracteres.').default(''),
    bloco: yup.string().label('Bloco').max(15, 'Máximo de 15 caracteres.').default(''),
    bairro: yup.string().label('Bairro').max(150, 'Máximo de 150 caracteres.').default(''),
    cidade: yup.string().label('Cidade').max(30, 'Máximo de 30 caracteres.').default(''),
    estado: yup
        .string()
        .label('Estado')
        .oneOf(estado_1.estado.map((m) => m.sigla).concat(['']))
        .default(''),
    religiao: yup.string().label('Religião').max(20, 'Máximo de 20 caracteres.').default(''),
    batizado: yup.bool().required().label('Batizado').default(false),
    ra: yup.string().label('Registro do Aluno').max(15, 'Máximo de 15 caracteres.').default(''),
    email: yup
        .string()
        .label('E-mail')
        .email('Formato de e-mail inválido.')
        .default('')
        .max(60, 'Máximo de 60 caracteres.'),
    escolaOrigem: yup.string().label('Escola de origem').max(80, 'Máximo de 80 caracteres.').default(''),
    estadoEscolaOrigem: yup
        .string()
        .label('Estado escola de origem')
        .oneOf(estado_1.estado.map((m) => m.sigla).concat(['']))
        .default(''),
    estadoCivil: yup
        .mixed()
        .label('Estado civil')
        //.oneOf(Object.values(EEstadoCivil))
        .default(enums_1.EEstadoCivil['Não Informado']),
    nacionalidade: yup.string().label('Nacionalidade').max(15, 'Máximo de 15 caracteres.').default(''),
    vacinaDt: (0, utils_1.sge2Date)().label('Validade vacinas').nullable().default(null),
    foneCelular: yup.string().label('Telefone Celular').max(15, 'Máximo de 15 caracteres.').default(''),
    foneResidencial: yup.string().label('Telefone Residencial').max(15, 'Máximo de 15 caracteres.').default(''),
    foneRecado: yup.string().label('Telefone Recado').max(15, 'Máximo de 15 caracteres.').default(''),
    ramal: yup.string().label('Ramal').max(5, 'Máximo de 5 caracteres.').default(''),
    contato: yup.string().label('Contato').max(35, 'Máximo de 35 caracteres.').default(''),
    dataIngresso: (0, utils_1.sge2Date)().label('Data do ingresso').nullable().default(null),
    dataSaida: (0, utils_1.sge2Date)().label('Data da saída').nullable().default(null),
    //Outros
    login: yup.string().label('Login').max(30, 'Máximo de 30 caracteres.').default(''),
    senha: yup.string().label('Senha').notRequired().max(15, 'Máximo de 15 caracteres.'),
    //Dados do Pai
    paiNome: yup.string().label('Nome').max(65, 'Máximo de 65 caracteres.').default(''),
    paiNome2: yup.string().label('Nome do pai2').max(65, 'Máximo de 65 caracteres.').default(''),
    paiDataNascimento: (0, utils_1.sge2Date)().label('Data de nascimento').nullable().default(null),
    paiDataNascimento2: (0, utils_1.sge2Date)().label('Data de nascimento pai2').nullable().default(null),
    paiCidade: yup.string().label('Cidade').max(30, 'Máximo de 30 caracteres.').default(''),
    paiEstado: yup
        .string()
        .label('Estado')
        .oneOf(estado_1.estado.map((m) => m.sigla).concat(['']))
        .default(''),
    paiCpf: yup.string().label('CPF').max(15, 'Máximo de 15 caracteres.').default(''),
    paiRg: yup.string().label('RG').max(15, 'Máximo de 15 caracteres.').default(''),
    paiEstadoCivil: yup.string().oneOf(enums_1.listaEstadoCivil).label('Estado civil').default(enums_1.listaEstadoCivil[0]),
    paiFalecido: yup.bool().required().label('Falecido').default(false),
    paiDesaparecido: yup.bool().required().label('Desaparecido').default(false),
    paiCep: yup.string().label('CEP').max(10, 'Máximo de 10 caracteres.').default(''),
    paiEndereco: yup.string().label('Endereço').max(55, 'Máximo de 55 caracteres.').default(''),
    paiNumero: yup.string().label('Número').max(5, 'Máximo de 5 caracteres.').default(''),
    paiApto: yup.string().label('Apartamento').max(15, 'Máximo de 15 caracteres.').default(''),
    paiBloco: yup.string().label('Bloco').max(15, 'Máximo de 15 caracteres.').default(''),
    paiBairro: yup.string().label('Bairro').max(150, 'Máximo de 150 caracteres.').default(''),
    paiProfissao: yup.string().label('Profissão').max(150, 'Máximo de 150 caracteres.').default(''),
    paiTrabalho: yup.string().label('Local de trabalho').max(150, 'Máximo de 150 caracteres.').default(''),
    paiFoneResidencial: yup.string().label('Telefone residencial').max(15, 'Máximo de 15 caracteres.').default(''),
    paiFoneRecado: yup.string().label('Telefone recado').max(15, 'Máximo de 15 caracteres.').default(''),
    paiFoneCelular: yup.string().label('Telefone celular').max(15, 'Máximo de 15 caracteres.').default(''),
    paiRamal: yup.string().label('Ramal').max(10, 'Máximo de 10 caracteres.').default(''),
    paiEmail: yup
        .string()
        .label('E-mail')
        .email('Formato de e-mail inválido.')
        .default('')
        .max(60, 'Máximo de 60 caracteres.'),
    paiReligiao: yup.string().label('Religião').max(20, 'Máximo de 20 caracteres.').default(''),
    paiObservacao: yup.string().label('Observação').max(100, 'Máximo de 100 caracteres.').default(''),
    paiEscolaridade: yup
        .mixed()
        .label('Escolaridade')
        //.oneOf(Object.values(EEscolaridade))
        .nullable()
        .default(enums_1.EEscolaridade.Nenhum),
    //
    guardaCompartilhada: yup.bool().required().label('Guarda compartilhada').default(false),
    //Dados da Mãe
    maeNome: yup.string().label('Nome').max(65, 'Máximo de 65 caracteres.').default(''),
    maeNome2: yup.string().label('Nome mãe2').max(65, 'Máximo de 65 caracteres.').default(''),
    maeDataNascimento: (0, utils_1.sge2Date)().label('Data de nascimento').nullable().default(null),
    maeDataNascimento2: (0, utils_1.sge2Date)().label('Data de nascimento mãe2').nullable().default(null),
    maeCidade: yup.string().label('Cidade').max(30, 'Máximo de 30 caracteres.').default(''),
    maeEstado: yup
        .string()
        .label('Estado')
        .oneOf(estado_1.estado.map((m) => m.sigla).concat(['']))
        .default(''),
    maeCpf: yup.string().label('CPF').max(15, 'Máximo de 15 caracteres.').default(''),
    maeRg: yup.string().label('RG').max(15, 'Máximo de 15 caracteres.').default(''),
    maeEstadoCivil: yup.string().oneOf(enums_1.listaEstadoCivil).label('Estado civil').default(enums_1.listaEstadoCivil[0]),
    maeFalecida: yup.bool().required().label('Falecida').default(false),
    maeDesaparecida: yup.bool().required().label('Desaparecida').default(false),
    maeCep: yup.string().label('CEP').max(10, 'Máximo de 10 caracteres.').default(''),
    maeEndereco: yup.string().label('Endereço').max(55, 'Máximo de 55 caracteres.').default(''),
    maeNumero: yup.string().label('Número').max(5, 'Máximo de 5 caracteres.').default(''),
    maeApto: yup.string().label('Apartamento').max(15, 'Máximo de 15 caracteres.').default(''),
    maeBloco: yup.string().label('Bloco').max(15, 'Máximo de 15 caracteres.').default(''),
    maeBairro: yup.string().label('Bairro').max(150, 'Máximo de 150 caracteres.').default(''),
    maeProfissao: yup.string().label('Profissão').max(150, 'Máximo de 150 caracteres.').default(''),
    maeTrabalho: yup.string().label('Local de trabalho').max(150, 'Máximo de 150 caracteres.').default(''),
    maeFoneResidencial: yup.string().label('Telefone residencial').max(15, 'Máximo de 15 caracteres.').default(''),
    maeFoneRecado: yup.string().label('Telefone recado').max(15, 'Máximo de 15 caracteres.').default(''),
    maeFoneCelular: yup.string().label('Telefone celular').max(15, 'Máximo de 15 caracteres.').default(''),
    maeRamal: yup.string().label('Ramal').max(10, 'Máximo de 10 caracteres.').default(''),
    maeEmail: yup
        .string()
        .label('E-mail')
        .email('Formato de e-mail inválido.')
        .default('')
        .max(60, 'Máximo de 60 caracteres.'),
    maeReligiao: yup.string().label('Religião').max(20, 'Máximo de 20 caracteres.').default(''),
    maeObservacao: yup.string().label('Observação').max(100, 'Máximo de 100 caracteres.').default(''),
    maeEscolaridade: yup
        .mixed()
        .label('Escolaridade')
        //.oneOf(Object.values(EEscolaridade))
        .nullable()
        .default(enums_1.EEscolaridade.Nenhum),
    cobrancaParaEsteAluno: yup.bool().required().label('Cobrança para este aluno').default(false),
    agruparCobranca: yup.bool().required().label('Agrupar cobrança').default(false),
    descontoPgtoEmDia: yup.bool().required().label('Desconto extra para pagamento em dia').default(false),
    valorDesconto: yup.number().label('Desconto').default(0),
    descontoPercentual: yup.bool().required().label('Considerar desconto em percentual').default(false),
    tipoResponsavel: yup
        .mixed()
        .label('Tipo responsável')
        .oneOf(Object.values(enums_1.EAlunoTipoResp))
        .default(enums_1.EAlunoTipoResp.Mae),
    //Censo
    raca: yup.mixed().label('Raça').default(enums_1.ERaca['0 - Sem declaração']),
    zonaResidencia: yup
        .mixed()
        .label('Zona de residência')
        .oneOf(Object.values(enums_1.EAlunoZonaResidencia))
        .default(enums_1.EAlunoZonaResidencia.Urbana),
    tipoNacionalidade: yup
        .mixed()
        .label('Nacionalidade do Aluno')
        .oneOf(Object.values(enums_1.EAlunoTipoNacionalidade))
        .default(enums_1.EAlunoTipoNacionalidade.Brasileira),
    paisOrigemHistorico: yup
        .string()
        .label('País origem personalizado p/ histórico escolar')
        .max(50, 'Máximo de 50 caracteres.')
        .default(''),
    //Mat Irmão
    tipoEscolaOrigem: yup
        .mixed()
        .label('Tipo da escola de origem')
        .oneOf(Object.values(enums_1.EAlunoTipoEscolaOrigem))
        .default(enums_1.EAlunoTipoEscolaOrigem.Publica),
    tipoSituacao: yup
        .mixed()
        .label('Situação')
        .oneOf(Object.values(enums_1.EAlunoTipoSituacao))
        .default(enums_1.EAlunoTipoSituacao.Novato),
    //Outros
    observacao: yup.string().label('Observação').max(350, 'Máximo de 350 caracteres.').default(''),
    certidaoNascimentoMatricula: yup
        .string()
        .label('Matrícula da certidão de nascimento')
        .max(100, 'Máximo de 100 caracteres.')
        .default(''),
    //Dados Médico
    tipoSanguineo: yup
        .mixed()
        .label('Tipo Sanguíneo')
        //.oneOf(Object.values(ETipoSanguineo))
        .nullable()
        .default(enums_1.ETipoSanguineo.Nenhum),
    alergia: yup.string().label('Tipo alergia').max(50, 'Máximo de 50 caracteres.').default(''),
    nomeMedico: yup.string().label('Nome do Médico').max(40, 'Máximo de 40 caracteres.').default(''),
    foneMedico: yup.string().label('Telefone do médico').max(15, 'Máximo de 15 caracteres.').default(''),
    remedio: yup.string().label('Nome do remédio').max(50, 'Máximo de 50 caracteres.').default(''),
    clinica: yup.string().label('Nome da clínica').max(50, 'Máximo de 50 caracteres.').default(''),
    planoSaude: yup.string().label('Plano de saúde').max(50, 'Máximo de 50 caracteres.').default(''),
    idCliente: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .integer()
        .default(null)
        .nullable()
        .label('Responsável Atual'),
    idImagemAluno: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .integer()
        .default(null)
        .nullable()
        .label('Imagem Aluno'),
    idImagemPai: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .integer()
        .default(null)
        .nullable()
        .label('Imagem Pai'),
    idImagemMae: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .integer()
        .default(null)
        .nullable()
        .label('Imagem Mãe'),
    idImagemResponsavel: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .integer()
        .default(null)
        .nullable()
        .label('Imagem Responsável'),
    anoMat: yup.string().nullable().notRequired().label('Ano Letivo').max(4, 'Máximo de 4 caracteres.').default(null),
    idCursoMat: yup
        .number()
        .default(null)
        .nullable()
        .label('Curso')
        .notRequired()
        .test('match', 'Selecione o curso', (idCursoMat, { parent: { anoMat } }) => !anoMat || (anoMat && idCursoMat) ? true : false),
    idSerieMat: yup
        .number()
        .default(null)
        .nullable()
        .label('Série')
        .notRequired()
        .test('match', 'Selecione a série', (idSerieMat, { parent: { anoMat } }) => {
        return !anoMat || (anoMat && idSerieMat) ? true : false;
    }),
    autorizacaoSaida: yup
        .bool()
        .required()
        .label('O aluno esta autorizado a sair das dependências do colégio sozinho')
        .default(false),
});
exports.schemaAluno = exports.yupAluno.shape({});
